var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNotice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.75A13.71 13.71 0 011.25 15 13.71 13.71 0 0115 1.25 13.71 13.71 0 0128.75 15 13.71 13.71 0 0115 28.75zm0-25c-6.25 0-11.25 5-11.25 11.25s5 11.25 11.25 11.25 11.25-5 11.25-11.25S21.25 3.75 15 3.75z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.25c-.75 0-1.25-.5-1.25-1.25v-5c0-.75.5-1.25 1.25-1.25s1.25.5 1.25 1.25v5c0 .75-.5 1.25-1.25 1.25zM15 21.25c-.375 0-.625-.125-.875-.375s-.375-.5-.375-.875c0-.125 0-.375.125-.5s.125-.25.25-.375c.375-.375.875-.5 1.375-.25.125 0 .125 0 .25.125 0 0 .125.125.25.125.125.125.25.25.25.375v.5c0 .125 0 .375-.125.5s-.125.25-.25.375c-.25.25-.5.375-.875.375z",
    fill: "#fff"
  })));
}

export default SvgIconNotice;